import { useNavigate } from 'react-router-dom';

import { RequireSession } from '../auth/RequireSession';
import { useSession } from '../auth/SessionContext';
import { useT } from '../i18n/LanguageContext';

import { AppLayout } from './AppLayout';
import { platformNavigation } from './platformNavigation';

export const PlatformShell = () => {
  const { profile, signOut } = useSession();
  const navigate = useNavigate();
  const t = useT();
  const user = profile?.kind === 'platform' ? profile.user : null;

  return (
    <RequireSession kind="platform">
      <AppLayout
        navigation={platformNavigation()}
        identity={
          user ? { primary: user.displayName ?? user.email, secondary: t('role.superAdmin') } : undefined
        }
        onSignOut={() => void signOut().then(() => navigate('/login'))}
      />
    </RequireSession>
  );
};
